import _URL from '../../URL/index';
const axios = _URL.axios;
const limit = 10

export default {
    services: {
        newReservations: (body, token) => {
            return axios(token).post(`/dispatch/reservations`, body);
        },
        getReservations: (pagination, query, token) => {
            if (Object.entries(pagination).length === 0) {
                return axios(token).get(`/dispatch/reservations?${query}`)
            } else {
                return (pagination.type === "change") ? axios(token).get(`/dispatch/reservations?limit=${limit}&page=${pagination.page}&${query}`) : axios(token).get(`${pagination.url}`);
            }
        },
        getOneReservation: (_id, token) => {
            return axios(token).get(`/reservations/${_id}`);
        },
        getSelectReservation: (_id, token) => {
            return axios(token).get(`/dispatch/reservations/${_id}`);
        },
        updateOneReservation: (_id, body, token) => {
            return axios(token).put(`/dispatch/reservations/${_id}`, body);
        },
        cancelReservations: (_id, reason, token) => {
            return axios(token).put(`/dispatch/cancel/reservations/${_id}`, { reason: reason });
        },
        nextReservations: async (_id, token) => {
            return axios(token).get(`/dispatch/driver/${_id}/getNextReservation`);
        }
    }
}